/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = Off 1 = Low 2 = Medium 3 = High
 */
export type BotDetectionSensitivity = 0 | 1 | 2 | 3;

export const BotDetectionSensitivity = {
  Off: 0 as BotDetectionSensitivity,
  Low: 1 as BotDetectionSensitivity,
  Medium: 2 as BotDetectionSensitivity,
  High: 3 as BotDetectionSensitivity,
};
